<!--
 * @Author: DY
 * @Date: 2024-11-19 16:38:03
 * @LastEditTime: 2025-03-20 18:56:11
 * @Description:
 * @FilePath: \ShiMo_Mobile\src\components\selectList\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="selectList">
            <HeaderNav
                header-title="选择列表"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @search="searchList" @clear="searchList"></van-search>
                <div class="listBox">
                    <template v-if="parameter.type == 'radio'">
                        <van-radio-group v-model="selectChecked">
                            <van-radio v-for="(item, index) in listData" :name="item[parameter.relationKey]" :key="`item_${index}`">
                                {{ item[parameter.showFieldName] }}
                            </van-radio>
                        </van-radio-group>
                    </template>
                    <template v-if="parameter.type == 'checkbox'">
                        <van-checkbox-group v-model="selectChecked">
                            <van-checkbox v-for="(item, index) in listData" :name="item[parameter.relationKey]" :key="`item_${index}`">
                                {{ item[parameter.showFieldName] }}
                            </van-checkbox>
                        </van-checkbox-group>
                    </template>
                </div>
                <footer class="currencyFooterStyle">
                    <button class="confirm" @click="confirmSelection">
                        确认选择
                    </button>
                </footer>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'select-list',
    mixins: [mixin_list],
    data() {
        return {
            parameter: {
                sourcePath: '/home',
                type: 'radio',
                listCode: '',
                requestUrl: '/basicplatform/tabledata',
                pageIndex: 0,
                pageSize: 999,
                tableList: [],
                callbackDataKey: '',
                showFieldName: 'stock_code',
                relationKey: 'id',
            },
            listData: [],
            selectChecked: null,
        };
    },
    filters: {},
    computed: {},
    watch: {},
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
        this.initPage();
    },
    mounted() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: this.parameter.sourcePath });
        },
        initPage() {
            this.parameter = Object.assign(this.parameter, this.$route.params);
            if (this.parameter.type === 'radio') {
                this.selectChecked = '';
            } else if (this.parameter.type === 'checkbox') {
                this.selectChecked = [];
            }
            this.searchList();
        },
        loadRequestData() {
            return {
                code: this.parameter.listCode,
                page: this.parameter.pageIndex,
                limit: this.parameter.pageSize,
                cacheKey: this.cacheKey,
            };
        },
        async searchList() {
            const requestData = this.loadRequestData();
            const data = await this.getListData(requestData);
            this.listData = data.rows;
        },
        confirmSelection() {
            let data = [];
            if (this.parameter.type === 'radio') {
                data = this.listData.filter(item => item[this.parameter.relationKey] === this.selectChecked);
            } else if (this.parameter.type === 'checkbox') {
                data = this.listData.filter(item => this.selectChecked.includes(item[this.parameter.relationKey]));
            }
            if ((data || []).length > 0) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: this.parameter.sourcePath,
                    params: {
                        [this.parameter.callbackDataKey]: data,
                    },
                });
            } else {
                this.$toast.fail('请先选择列表数据！');
            }
        },
        getListData(requestData) {
            return this.$axios.$post(`/interfaceApi${this.parameter.requestUrl}`, requestData, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.selectList
    height 100%
    display: flex;
    flex-direction column
    section
        flex: 1
        height: 0
        .listBox
            height calc(100% - 104rpx)
            padding 14rpx
            .van-radio-group,.van-checkbox-group
                display flex
                flex-wrap wrap
                justify-content space-between
                .van-radio,.van-checkbox
                    width calc(50% - 5rpx)
                    height: 32rpx
                    margin-bottom: 10rpx
                    .van-radio__icon,.van-checkbox__icon
                        display none
                        &+.van-radio__label,&+.van-checkbox__label
                            width 100%
                            height: 32rpx
                            line-height 30rpx
                            margin: 0
                            text-align: center
                            border-radius: 4rpx
                            border 1px solid #F0F0F0
                            background: #F8F8F8
                            font-size 14rpx
                            color #626262
                        &.van-radio__icon--checked,&.van-checkbox__icon--checked
                            &+.van-radio__label,&+.van-checkbox__label
                                border-color: rgba(233, 55, 67, 0.10)
                                background: rgba(233, 55, 67, 0.2)
                                color #E93743
</style>
